import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  IAgencyRequirementsResponse,
  IFetchRequirementsError,
  IFetchRequirementsPayload,
} from '../../../types/discovery/AgencyDiscovery.types';

export interface IAgencyDiscoveryState {
  requirements: IAgencyRequirementsResponse | null;
  loading: boolean;
  error: IFetchRequirementsError | null;
}

export const AgencyDiscoveryInitialState: IAgencyDiscoveryState = {
  requirements: null,
  loading: false,
  error: null,
};

const agencyDiscoverySlice = createSlice({
  name: 'agencyDiscovery',
  initialState: AgencyDiscoveryInitialState,
  reducers: {
    fetchRequirements: (
      state,
      action: PayloadAction<IFetchRequirementsPayload>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchRequirementsSucceeded: (
      state,
      action: PayloadAction<IAgencyRequirementsResponse>
    ) => {
      state.loading = false;
      state.requirements = action.payload;
      state.error = null;
    },
    fetchRequirementsFailed: (
      state,
      action: PayloadAction<{ error: IFetchRequirementsError }>
    ) => {
      state.loading = false;
      state.requirements = null;
      state.error = action.payload.error;
    },
    resetRequirements: (state) => {
      state.requirements = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchRequirements,
  fetchRequirementsSucceeded,
  fetchRequirementsFailed,
  resetRequirements,
} = agencyDiscoverySlice.actions;

export default agencyDiscoverySlice.reducer;
